import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FullscreenService } from './../../../../core/services/fullscreen.service';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ConsultationsService } from '../../../../core/services/consultation/consultations.service';
import {
  catchError,
  interval,
  map,
  Observable,
  of,
  Subscription,
  switchMap,
  takeWhile,
} from 'rxjs';
import { PatientsService } from '../../../../core/services/patient/patients.service';
import { CurrentUserService } from '../../../../core/services/user/current-user.service';
import { ChatService } from '../../../../core/services/chat/chat.service';
import { CreateChatModel } from '../../../../core/models/chat/create-chat-model';
import { StatusUtils } from '../../../../utils/status-utils';
import { SignalRService } from '../../../../core/services/signalR/signalR';
import { environment } from '../../../../../environments/environment';
import { CaseStatus } from '../../../../../enums/case-status.enum';
import { FullscreenOverlayComponent } from '../../../components/fullscreen-overlay/fullscreen-overlay.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UserSessionModel } from '../../../../core/models/user/current-user.model';
import { ConclusioOptions } from '../../../../core/models/consultation/conclusion-options.model';
import { TimelineListModel } from '../../../../core/models/consultation/timeline-list.model';
import { ChatListModel } from '../../../../core/models/chat/chat-list.model';
import { NotificationTemplateModel } from '../../../../core/models/notification/notification-template.model';
import { AiImagesModel } from '../../../../core/models/consultation/ai-images.model';
import { SkinTypes } from '../../../../../enums/skin-types.enum';
import { ImgEditorComponent } from '../../../components/img-editor/img-editor.component';
import { CaseBreadcrumbComponent } from '../../../components/case-breadcrumb/case-breadcrumb.component';
import { GaugeChartComponent } from '../../../components/gauge-chart/gauge-chart.component';
import { PatientCaseModel } from '../../../../core/models/consultation/patient-case.model';
import { SelectedConclusionModel } from '../../../../core/models/consultation/selected-conclusion.model';
import { ConclusionOptionInfoModel } from '../../../../core/models/consultation/conclusion-option-info.model';
import { AnnotationListModel } from '../../../../core/models/consultation/annotation-list.model';
import { UserRole } from '../../../../../enums/roles.enum';
import {
  ADVANCED_EXAMINATION,
  COLOR_OPTION_ID,
  BORDER_OPTION_ID,
  IRREGULAR_STREAKS_PSEUDOPODS_ID,
  LENTIGO_MALIGNA_ID,
  MELANOMA_ID,
  RECOMMENDATION_OPTION_ID,
} from '../../../constants/constants';
import { ToastService } from '../../../../core/services/toast.service';
import { SelectedOptionModel } from '../../../../core/models/consultation/selected-option.model';
import { SelectedOptionsArrayModel } from '../../../../core/models/consultation/selected-options-array.model';
import { UsersService } from '../../../../core/services/user/users.service';
import {
  BENIGN_SKIN_CONDITIONS,
  PRE_MALIGNANT_SKIN_CONDITIONS,
  MALIGNANT_SKIN_CONDITIONS,
} from '../../../constants/constants';
import { DiagnosisSubcategoryModel } from '../../../../core/models/consultation/diagnosis-subcategory-model.model';
import { SkinAnalysisMetricsModel } from '../../../../core/models/consultation/skin-analysis-metrics.model';
declare var bootstrap: any;
import { InputValidationService } from '../../../../core/services/input-validation.service';

@Component({
  selector: 'app-consultation-detail',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    FullscreenOverlayComponent,
    TranslateModule,
    ImgEditorComponent,
    CaseBreadcrumbComponent,
    GaugeChartComponent,
    RouterModule,
  ],
  templateUrl: './consultation-detail.component.html',
  styleUrl: './consultation-detail.component.scss',
  providers: [DatePipe],
})
export class ConsultationDetailComponent {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('chatContainer') chatContainer!: ElementRef;
  @ViewChildren('magnifierContainer') containers!: QueryList<ElementRef>;
  @ViewChildren('magnifierLens') lenses!: QueryList<ElementRef>;
  @ViewChildren('magnifierImage') images!: QueryList<ElementRef>;
  @ViewChild('leftFirstTab') leftFirstTab!: ElementRef<HTMLAnchorElement>;
  @ViewChild('rightFirstTab') rightFirstTab!: ElementRef<HTMLAnchorElement>;

  caseStatus = CaseStatus;
  constructor(
    private inputValidationService: InputValidationService,
    private fullscreenService: FullscreenService,
    private route: ActivatedRoute,
    private consultationsService: ConsultationsService,
    private patientsService: PatientsService,
    private usersService: UsersService,
    private chatService: ChatService,
    private currentUserService: CurrentUserService,
    private signalRService: SignalRService,
    private router: Router,
    private translate: TranslateService,
    private toastService: ToastService,
    private ch: ChangeDetectorRef
  ) {
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);
    this.createConsultationConnection();

    this.createChatConnection();
    // this.createPatientImageConnection();
  }
  selectedItem: any;
  consultationId: string = '';
  activeCase: PatientCaseModel;
  patientRecordId: string = '';
  patientCases: PatientCaseModel[];
  selectedConclusionOptions: SelectedConclusionModel[] = [];
  patientHeaderInformations: any = [];
  patientRecordCaseImages: any = [];
  isImagesLoading: boolean = true;
  timeLineList: TimelineListModel[] = [];
  patientCaseDetails: any = [];
  selectedIndex: number | null = null;
  currentUser: UserSessionModel | null = null;
  conclusionOptions: ConclusioOptions[] = [];
  selectedConclusionText: string = '';
  selectedConclusions: { [key: string]: string } = {};
  pdfSrc: any = null;
  patientRapport: any = null;
  isConsultationReportTabActive = false;
  private tabChangeListener: any;
  chatList: ChatListModel[] = null;
  messageText: string = '';
  file: File | null = null;
  fileCount: any = null;
  private interval: any;
  reportError: string = '';
  userInput: string = '';
  isUpdatingFromInput = false;
  previewReportErrorText: string = '';
  statusClass: string;
  statusText: string;
  isOverlayLoading: boolean = false;
  isChatSending: boolean = false;
  selectedImage: any = null;
  radioSelectedImage: any = null;
  showImageGallery: boolean = true;
  patientHistoryImages: any = [];
  patientCaseReportImages: any;
  currentCaseData: {
    src: any;
    isSelected: boolean;
    isReportImage: boolean;
    imageId: string;
    patientRecordCaseId: string;
  } = {
      src: null,
      isSelected: false,
      isReportImage: false,
      imageId: '',
      patientRecordCaseId: '',
    };
  historyCaseDataList: Array<{
    src: string | null;
    isSelected: boolean;
    isReportImage: boolean;
    imageId: string;
    patientRecordCaseId: string;
  }> = [];
  fullscreenImage: {
    src: any;
    isSelected: boolean;
    isReportImage: boolean;
    imageId: string;
    patientRecordCaseId: string;
  } = {
      src: null,
      isSelected: false,
      isReportImage: false,
      imageId: '',
      patientRecordCaseId: '',
    };
  selectedImageIndex: number = 0;
  allCaseImageTabVisibilty: boolean = false;
  activeTab: '#caseImage' | '#allCaseImages' = '#caseImage';
  activeRightTab: '#conclusion' | '#aiReport' | '#caseHistory' | '#chatWithGp' =
    '#conclusion';
  notificationTemplate: NotificationTemplateModel = {
    id: '',
    subject: '',
    body: '',
    notificationType: 0,
  };
  notificationMailTemplate: any;
  aiImages: AiImagesModel = {
    gaugeImage: '',
    radarChartImage: '',
    lesionSpaceImage: '',
    cbirImage: '',
    blendedImage: '',
    spaceImage: '',
    saturationSpaceImage: '',
    cbir1Image: '',
    cbir2Image: '',
    cbir3Image: '',
    cbir4Image: '',
    cbir5Image: '',
    gaugeRate: '',
    cbir1Value: '',
    cbir2Value: '',
    cbir3Value: '',
    cbir4Value: '',
    cbir5Value: '',
    allImagesExist: false,
  };
  firstImage: any = [];
  showFullText: boolean = false;
  showMedicationFullText: boolean = false;
  showImageGalleryAi: boolean = true;
  isAiLoading: boolean = true;
  fullscreenImageAi: any = null;
  subscription: Subscription;
  defaultUserImage: string | ArrayBuffer | null = null;
  currentUserAvatar: string | ArrayBuffer | null = null;
  otherUserAvatar: string | ArrayBuffer | null = null;
  otherUserName: string = '';
  annotationList: AnnotationListModel[] = [];
  drawnRects: any[] = [];
  userRole = UserRole;
  selectedOption: SelectedOptionModel = {
    id: '',
    title: '',
    conclusionText: '',
    conclusionOptionId: '',
    applicationCode: 0,
  };
  isComeFromReferral: boolean = false;
  selectedOptionsArray: SelectedOptionsArrayModel[] = [];
  diagnoses: { id: string; name: string; order: number }[] = [];
  benignSubcategories: DiagnosisSubcategoryModel[] = [];
  preMalignantSubcategories: DiagnosisSubcategoryModel[] = [];
  malignantSubcategories: DiagnosisSubcategoryModel[] = [];
  selectedDiagnosis: string = '';
  selectedSubcategory: string = '';
  benignSkinConditions = BENIGN_SKIN_CONDITIONS;
  preMalignantSkinConditions = PRE_MALIGNANT_SKIN_CONDITIONS;
  malignantSkinConditions = MALIGNANT_SKIN_CONDITIONS;
  activeTabList: string[] = [];
  showDisableButtonDesc: boolean = false;
  enEvent: boolean = false;
  isRecommendationDisabled = false;
  ADVANCED_EXAMINATION_ID = ADVANCED_EXAMINATION;
  RECOMMENDATION_OPTION_ID = RECOMMENDATION_OPTION_ID;
  recommendationOption: any = null;
  selectedAIReportSection: 'tdsScoring' | 'asymmetry' | 'borderIrregularity' | 'color' | 'diameter' = 'tdsScoring';
  skinAnalysisMetrics: SkinAnalysisMetricsModel | null = null;

  readonly isDebugDomain: boolean = (() => {
    const host = window.location.hostname;
    return host === 'localhost' || host === 'dermalogic.amatis.dev';
  })();


  async ngOnInit() {
    await StatusUtils?.initializeTranslateService(this.translate);
    this.fullscreenService.initializeFullscreenButtons();
    this.patientRecordId = this.route.snapshot.paramMap.get('id')!;
    this.currentUser = this.currentUserService.GetSession();
    this.isComeFromReferral = window.location.href.includes('referral')
      ? true
      : false;
    this.getConclusionOptions();
    this.getDiagnoseTypeCategoryList();

    // MOCK DATA INJECTION FOR MOCKUP REQUEST
    // this.setMockData(); // Devre dışı - gerçek backend verisi test edilecek
  }

  ngAfterViewInit() {
    this.tabChangeListener = this.handleTabChange.bind(this);
    document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
      tab.addEventListener('shown.bs.tab', this.tabChangeListener);
    });

    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl, {
        customClass: 'custom-tooltip',
        placement: 'bottom',
      });
    });
  }

  ngAfterViewChecked() {
    if (!this.enEvent) {
      this.containers.forEach((containerRef, index) => {
        const container = containerRef.nativeElement;
        const lens = this.lenses.toArray()[index].nativeElement;
        const image = this.images.toArray()[index].nativeElement;

        if (container && lens && image) {
          this.enEvent = true;
          container.addEventListener('mousemove', (e: MouseEvent) => {
            const { top, left, width, height } =
              container.getBoundingClientRect();
            const lensSize = lens.offsetWidth / 2;
            lens.style.display = 'block';
            let x = e.pageX - left - lensSize;
            let y = e.pageY - top - lensSize;

            if (x > width - lensSize * 2) x = width - lensSize * 2;
            if (y > height - lensSize * 2) y = height - lensSize * 2;
            if (x < 0) x = 0;
            if (y < 0) y = 0;

            lens.style.left = x + 'px';
            lens.style.top = y + 'px';
            lens.style.backgroundImage = `url(${image.src})`;
            lens.style.backgroundPosition = `-${x * 2}px -${y * 2}px`;
            lens.style.backgroundSize = `${width * 2}px ${height * 2}px`;
          });

          container.addEventListener('mouseleave', () => {
            lens.style.display = 'none';
          });
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
      tab.removeEventListener('shown.bs.tab', this.tabChangeListener);
    });
    this.removeDoctor();
  }

  setUserPermission(): Boolean {
    return (
      this.currentUser?.role === UserRole.Dermatologist ||
      this.currentUser?.role === UserRole.GeneralPractitioner ||
      this.currentUser?.role === UserRole.Admin ||
      this.currentUser?.role === UserRole.OrganizationAdmin
    );
  }

  selectTab(tab: 'aiReport' | 'caseHistory' | 'chatWithGp') {
    this.activeTabList.push(tab);
  }

  onDiagnosisChange() {
    this.selectedSubcategory = '';

    this.consultationsService
      .diagnoseTypeContentListByCategory(this.selectedDiagnosis)
      .subscribe({
        next: (res) => {
          if (this.selectedDiagnosis === this.benignSkinConditions) {
            this.benignSubcategories = res;
          } else if (
            this.selectedDiagnosis === this.preMalignantSkinConditions
          ) {
            this.preMalignantSubcategories = res;
          } else if (this.selectedDiagnosis === this.malignantSkinConditions) {
            this.malignantSubcategories = res;
          }
        },
      });
  }

  getSelectedSubcategoryObj(): DiagnosisSubcategoryModel | undefined {
    if (this.selectedDiagnosis === this.benignSkinConditions) {
      return this.benignSubcategories.find(x => x.id === this.selectedSubcategory);
    } else if (this.selectedDiagnosis === this.preMalignantSkinConditions) {
      return this.preMalignantSubcategories.find(x => x.id === this.selectedSubcategory);
    } else if (this.selectedDiagnosis === this.malignantSkinConditions) {
      return this.malignantSubcategories.find(x => x.id === this.selectedSubcategory);
    }
    return undefined;
  }

  onSubcategoryChange(type: 'benign' | 'preMalignant' | 'malignant') {
    if (type === 'benign') {
      this.selectedConclusionText = this.benignSubcategories.find(
        (x) => x.id === this.selectedSubcategory
      )?.description;
      this.isRecommendationDisabled = false;
    } else if (type === 'preMalignant') {
      this.selectedConclusionText = this.preMalignantSubcategories.find(
        (x) => x.id === this.selectedSubcategory
      )?.description;
      this.isRecommendationDisabled = false;
    } else if (type === 'malignant') {
      const selected = this.malignantSubcategories.find(
        (x) => x.id === this.selectedSubcategory
      );
      if (
        selected?.id === LENTIGO_MALIGNA_ID ||
        selected?.id === MELANOMA_ID
      ) {
        this.isRecommendationDisabled = true;

        this.recommendationOption = this.selectedConclusionOptions.find(
          (x) => x.optionId === RECOMMENDATION_OPTION_ID
        );
        if (this.recommendationOption) {
          this.recommendationOption.conclusionTextId = ADVANCED_EXAMINATION;
          const foundOption = this.conclusionOptions.find(options => RECOMMENDATION_OPTION_ID === options.id);
          if (foundOption) {
            const foundContent = foundOption.conclusionOptionContents.find(content => ADVANCED_EXAMINATION === content.id);
            if (foundContent) {
              this.recommendationOption.conclusionText = foundContent.conclusionText;
            }
          }
        }
      } else {
        this.isRecommendationDisabled = false;
      }
    }
  }

  annotationListChange(e: { annotationList: any[]; drawnRects: any[] }) {
    this.annotationList = e.annotationList;
    this.drawnRects = e.drawnRects;
    this.setSelectedConsultationText();
  }

  async saveCaseAndNext() {
    const conclusionOptionInfos: ConclusionOptionInfoModel[] = [];
    for (const item of this.selectedConclusionOptions) {
      const newItem: ConclusionOptionInfoModel = {
        conclusionOptionId: item.optionId,
        conclusionOptionContentId: item.conclusionTextId,
      };

      if (item.optionId === COLOR_OPTION_ID) {
        newItem.annotations = this.drawnRects
          .filter(
            (rect) =>
              rect.selectedAnnotationId !== IRREGULAR_STREAKS_PSEUDOPODS_ID
          )
          .map((rect) => ({
            annotationId: rect.selectedAnnotationId,
          }));
      } else if (item.optionId === BORDER_OPTION_ID) {
        newItem.annotations = this.drawnRects
          .filter(
            (rect) =>
              rect.selectedAnnotationId === IRREGULAR_STREAKS_PSEUDOPODS_ID
          )
          .map((rect) => ({
            annotationId: rect.selectedAnnotationId,
          }));
      } else {
        newItem.annotations = [];
      }

      conclusionOptionInfos.push(newItem);
    }
    await this.consultationsService.completePatientRecordCase(
      this.consultationId,
      this.selectedDiagnosis !== this.malignantSkinConditions
        ? []
        : conclusionOptionInfos,
      this.selectedSubcategory
    );

    const caseKey = `selectedConclusionOptions_${this.activeCase?.patientRecordCaseId}`;
    localStorage.removeItem(caseKey);

    await this.getCasesByRecordId();
    this.goToNextCase();
  }

  goToNextCase() {
    const currentCaseIndex = this.patientCases.findIndex(
      (x) => x.patientRecordCaseId === this.activeCase.patientRecordCaseId
    );
    this.activeCase = this.patientCases[currentCaseIndex + 1];
    this.consultationId = this.activeCase.patientRecordCaseId;
    this.initAfterActiveCaseChange();
  }

  protected async createConsultationConnection() {
    const signalRBasePath = `${environment.apiLocations.patient}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'patient-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receivePatientUpdated', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (parsedJson?.PatientRecordCaseId === this.consultationId) {
        this.patientHeaderInformations.patientStatus = parsedJson.PatientStatus;
      }
    });
  }

  protected async closeConsultation() {
    const signalRBasePath = `${environment.apiLocations.patient}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'patient-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receiveConsultationClosed', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (parsedJson?.PatientRecordId === this.patientRecordId) {
        this.router.navigate(['/consultation/list']);
      }
    });
  }

  reset() {
    this.leftFirstTab?.nativeElement?.click();
    this.rightFirstTab?.nativeElement?.click();
    this.closeAiImagesFullscreen();
    this.showDisableButtonDesc = false;
    this.currentCaseData = {
      src: null,
      isSelected: false,
      isReportImage: false,
      imageId: '',
      patientRecordCaseId: '',
    };
    this.selectedConclusionOptions = [];
    this.selectedConclusionText = '';
    this.statusClass = '';
    this.statusText = '';
    this.patientRecordCaseImages = [];
    this.selectedImage = null;
    this.timeLineList = [];
    this.patientCaseDetails = [];
    this.patientHistoryImages = [];
    this.patientCaseReportImages = null;
    this.aiImages = {
      gaugeImage: '',
      radarChartImage: '',
      lesionSpaceImage: '',
      cbirImage: '',
      blendedImage: '',
      spaceImage: '',
      saturationSpaceImage: '',
      cbir1Image: '',
      cbir2Image: '',
      cbir3Image: '',
      cbir4Image: '',
      cbir5Image: '',
      gaugeRate: '',
      cbir1Value: '',
      cbir2Value: '',
      cbir3Value: '',
      cbir4Value: '',
      cbir5Value: '',
      allImagesExist: false,
    };
    this.chatList = null;
    this.selectedDiagnosis = '';
    this.selectedSubcategory = '';
    this.skinAnalysisMetrics = null;
    // this.setMockData(); // Devre dışı - gerçek backend verisi test edilecek
  }

  async initAfterActiveCaseChange() {
    this.reset();
    this.getPatientCaseDetail(this.consultationId);
    await this.getAiImages();
  }

  mouseEnterInBreadcrumb(event: MouseEvent) {
    const button = document.getElementById('myAcordionButton') as HTMLElement;
    button?.setAttribute('data-bs-toggle', '');
  }

  mouseLeaveInBreadcrumb(event: MouseEvent) {
    const button = document.getElementById('myAcordionButton') as HTMLElement;
    button?.setAttribute('data-bs-toggle', 'collapse');
  }

  protected async createChatConnection() {
    const signalRBasePath = `${environment.apiLocations.chat}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'chat-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receiveChatAdded', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (parsedJson.PatientRecordCaseId === this.consultationId) {
        if (parsedJson?.Message) {
          const newMessage = {
            chatId: parsedJson.ChatId,
            patientRecordCaseId: parsedJson.PatientRecordCaseId,
            createdUserId: parsedJson.CreatedUserId,
            createdUserName: parsedJson.CreatedUserName,
            message: parsedJson.Message,
            chatFiles: parsedJson.ChatFiles || [],
            createdDateTime: parsedJson.CreatedDateTime,
            relativeTime: parsedJson.RelativeTime,
          };
          this.chatList = [...this.chatList, newMessage];
          setTimeout(() => {
            this.scrollToBottom();
          }, 500);
        }
      }
    });
  }

  protected async createPatientImageConnection() {
    const signalRBasePath = `${environment.apiLocations.patient}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'patient-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receiveImageUploaded', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (parsedJson.PatientRecordCaseId === this.consultationId) {
        if (parsedJson) {
          const image = {
            createdDate: parsedJson.CreatedDate,
            fileData: parsedJson.FileData,
            fileName: parsedJson.FileName,
            id: parsedJson.PatientRecordCaseImageId,
            isSelected: parsedJson.IsSelected,
          };
          this.patientRecordCaseImages = [
            image,
            ...this.patientRecordCaseImages,
          ];
        }
      }
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    this.removeDoctor();
  }

  removeDoctor() {
    this.consultationsService
      .removeDoctorFromPatientRecord(this.patientRecordId)
      .subscribe({
        next: () => { },
      });
  }

  handleTabChange(event: Event) {
    const target = event.target as HTMLElement;
    const href = target.getAttribute('href');
    if (href === '#chatWithGp') {
      this.activeRightTab = '#chatWithGp';
      this.getChatList(this.consultationId);
      if (
        this.currentUser?.role === this.userRole.OrganizationAdmin ||
        this.currentUser?.role === this.userRole.Assistant
      ) {
        this.isChatSending = true;
      }
      setTimeout(() => {
        this.scrollToBottom();
      }, 500);
      this.markMessagesAsRead(this.consultationId);
    } else if (href === '#consultationHistory') {
      this.getPatientConsultationImageHistory(this.consultationId);
      setTimeout(() => {
        this.scrollToBottom();
      }, 500);
    } else if (href === '#conclusion') {
      this.activeRightTab = '#conclusion';
    } else if (href === '#aiReport') {
      this.activeRightTab = '#aiReport';
      this.getSkinAnalysisMetrics(this.consultationId);
      this.ch.detectChanges();
      // Render charts if the current section has a chart
      if (['asymmetry', 'borderIrregularity', 'color', 'diameter'].includes(this.selectedAIReportSection)) {
        setTimeout(() => this.renderCharts(), 100);
      }
    } else if (href === '#caseHistory') {
      this.activeRightTab = '#caseHistory';
    } else if (href === '#allCaseImages') {
      this.activeTab = '#allCaseImages';
    } else if (href === '#caseImage') {
      this.activeTab = '#caseImage';
    }
  }

  markMessagesAsRead(caseId: string) {
    this.chatService.markMessagesAsRead(caseId).subscribe({
      next: () => { },
    });
  }

  getAIReport(id: string) {
    this.consultationsService
      .patientRecordCaseReportsByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          if (res?.patientRapport === '') {
            this.reportError = this.translate.instant('errorNoAIReport');
          } else {
            this.reportError = '';
            this.displayPdf(res.patientRapport, 'ai');
          }
        },
      });
  }

  toggleShowFullText(event: Event): void {
    event.preventDefault();
    this.showFullText = !this.showFullText;
  }

  toggleShowMedicationFullText(event: Event): void {
    event.preventDefault();
    this.showMedicationFullText = !this.showMedicationFullText;
  }



  setMockData() {
    this.skinAnalysisMetrics = {
      id: 'mock-1',
      patientRecordCaseId: 'mock-case-1',
      fileName: '/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped',
      patientId: 'patient-1',
      patientRecordId: 'record-1',
      customerCode: 'cust-1',
      customerId: 'cust-id-1',
      deviceSerialNo: 'dev-1',
      tdsScore: 3.5,
      tdsClassification: 'Benign',
      isMalignant: false,
      malignantProbability: 0.4035090357065201,
      predictedClass: 'NV',
      success: true,
      createdDate: new Date(),
      updatedDate: null,
      analysis: {
        fileName: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped",
        success: true,
        message: "SUCCESS",
        tdsScore: 3.5,
        tdsClassification: "Benign",
        tdsRiskMessage: "TDS Score: 3.50 - Benign lesion. Regular monitoring recommended.",
        abcdeScores: {
          asymmetry: 0.0,
          border: 0.0,
          color: 3.0,
          diameter: 4.0,
          evolution: 0.0,
          colorsDetected: [
            "Red",
            "LightBrown",
            "DarkBrown"
          ],
          majorAxisPx: 207.17544555664062,
          minorAxisPx: 182.96875
        },
        classification: {
          predictedClass: "NV",
          predictedClassName: "Melanocytic Nevi",
          isMalignant: false,
          malignantProbability: 0.4035090357065201,
          classProbabilities: {
            "AKIEC": 0.13450300693511963,
            "BCC": 0.13450300693511963,
            "BKL": 0.1345030665397644,
            "DF": 0.13450300693511963,
            "MEL": 0.13450302183628082,
            "NV": 0.19298195838928223,
            "VASC": 0.13450300693511963
          }
        },
        visualizations: {
          asymmetryMap: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.asymmetry.png",
          borderGraph: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.border.png",
          colorHistogram: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.color_hist.png",
          diameterGraph: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.diameter.png",
          gaugeChart: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.gauge.png",
          lesionOverlay: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.lesion.space.png",
          cbirComparison: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.cbir.png",
          maskImage: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.mask.png"
        },
        metrics: {
          asymmetry: {
            rotationAngles: [
              0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330
            ],
            rotationScores: [
              0.9251067626999809,
              0.8977501256913022,
              0.8534953661081446,
              0.9358415587745161,
              0.8846033826374586,
              0.8520176622102293,
              0.9289181249201686,
              0.8940600890673023,
              0.8577140748031497,
              0.9446912626360183,
              0.8828407532111235,
              0.854861494994165
            ],
            bestAxisAngle: 270,
            bestAxisScore: 0.9446912626360183,
            worstAxisAngle: 150,
            worstAxisScore: 0.8520176622102293,
            meanScore: 0.8926583881461299,
            stdScore: 0.03286861784459918,
            assessment: "LOW"
          },
          border: {
            segmentAngles: [
              "0°",
              "45°",
              "90°",
              "135°",
              "180°",
              "225°",
              "270°",
              "315°"
            ],
            segmentScores: [
              0.056884497488303376,
              0.05472127298679471,
              0.06777786220660446,
              0.06868135199804522,
              0.11229966024515767,
              0.072536783895121,
              0.07120182783520684,
              0.05506209506507299
            ],
            totalScore: 0.0,
            irregularSegments: 0
          },
          color: {
            colorsDetected: {
              "White": false,
              "Red": true,
              "LightBrown": true,
              "DarkBrown": true,
              "BlueGray": false,
              "Black": false
            },
            colorsCount: 3,
            hueHistogramBins: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170],
            hueHistogramCounts: [11239, 5896, 447, 25, 10, 8, 4, 1, 5, 3, 6, 19, 52, 136, 255, 1220, 2512, 8365]
          },
          diameter: {
            majorAxisPx: 207.17544555664062,
            minorAxisPx: 182.96875,
            aspectRatio: 0.8831584723199128,
            rotationAngle: 98.07711029052734,
            centerX: 197,
            centerY: 270,
            areaPx: 29865.5
          }
        }
      }
    };
  }

  selectAIReportSection(section: 'tdsScoring' | 'asymmetry' | 'borderIrregularity' | 'color' | 'diameter') {
    this.selectedAIReportSection = section;
    this.ch.detectChanges();
    setTimeout(() => {
      this.renderCharts();
    }, 100);
  }

  renderCharts() {
    console.log('renderCharts called. Section:', this.selectedAIReportSection);
    if (!this.skinAnalysisMetrics?.analysis) {
      console.warn('No skinAnalysisMetrics.analysis found');
      return;
    }

    if (this.selectedAIReportSection === 'asymmetry') {
      this.renderAsymmetryChart();
    } else if (this.selectedAIReportSection === 'borderIrregularity') {
      this.renderBorderChart();
    } else if (this.selectedAIReportSection === 'color') {
      this.renderColorChart();
    } else if (this.selectedAIReportSection === 'diameter') {
      this.renderDiameterChart();
    }
  }

  renderAsymmetryChart() {
    console.log('Rendering Asymmetry Chart...');
    const canvas = document.getElementById('asymmetryChart') as HTMLCanvasElement;
    if (!canvas) {
      console.error('Canvas element #asymmetryChart not found');
      return;
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const metrics = this.skinAnalysisMetrics?.analysis?.metrics?.asymmetry;
    console.log('Asymmetry metrics:', metrics);
    if (!metrics?.rotationScores || !metrics?.rotationAngles) {
      console.warn('Missing asymmetry metrics data');
      return;
    }

    // Set canvas parent to full height
    if (canvas.parentElement) {
      canvas.parentElement.style.height = '100%';
      canvas.parentElement.style.display = 'flex';
      canvas.parentElement.style.alignItems = 'center';
      canvas.parentElement.style.justifyContent = 'center';
    }

    // Destroy existing chart if any
    const existingChart = Chart.getChart(canvas);
    if (existingChart) existingChart.destroy();

    new Chart(ctx, {
      type: 'radar',
      data: {
        labels: metrics.rotationAngles.map(a => `${a}°`),
        datasets: [{
          label: 'Asymmetry Score',
          data: metrics.rotationScores,
          backgroundColor: 'rgba(102, 126, 234, 0.2)',
          borderColor: 'rgba(102, 126, 234, 1)',
          borderWidth: 2,
          pointBackgroundColor: 'rgba(102, 126, 234, 1)'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { top: 10, bottom: 10, left: 10, right: 10 }
        },
        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text: 'Rotation Scores (0-360°)',
            padding: { top: 5, bottom: 5 },
            font: { size: 11 }
          }
        },
        scales: {
          r: {
            min: 0,
            max: 1,
            grid: { color: 'rgba(0,0,0,0.07)' },
            ticks: { stepSize: 0.2, font: { size: 10 } },
            pointLabels: { font: { size: 10 } }
          }
        }
      }
    });
  }

  renderBorderChart() {
    const canvas = document.getElementById('borderChart') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const metrics = this.skinAnalysisMetrics?.analysis?.metrics?.border;
    if (!metrics?.segmentScores || !metrics?.segmentAngles) return;

    // Set canvas parent to full height
    if (canvas.parentElement) {
      canvas.parentElement.style.height = '100%';
      canvas.parentElement.style.display = 'flex';
      canvas.parentElement.style.alignItems = 'center';
      canvas.parentElement.style.justifyContent = 'center';
    }

    const existingChart = Chart.getChart(canvas);
    if (existingChart) existingChart.destroy();

    new Chart(ctx, {
      type: 'polarArea',
      data: {
        labels: metrics.segmentAngles,
        datasets: [{
          label: 'Border Irregularity',
          data: metrics.segmentScores,
          backgroundColor: [
            'rgba(255, 107, 107, 0.75)',
            'rgba(255, 107, 107, 0.60)',
            'rgba(255, 142, 83, 0.75)',
            'rgba(255, 142, 83, 0.60)',
            'rgba(255, 107, 107, 0.45)',
            'rgba(255, 142, 83, 0.45)',
            'rgba(255, 107, 107, 0.30)',
            'rgba(255, 142, 83, 0.30)'
          ]
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { top: 10, bottom: 10, left: 10, right: 10 }
        },
        plugins: {
          legend: {
            position: 'right',
            labels: { font: { size: 9 } }
          },
          title: {
            display: true,
            text: 'Segment Irregularity Scores',
            padding: { top: 5, bottom: 5 },
            font: { size: 11 }
          }
        }
      }
    });
  }

  renderColorChart() {
    const canvas = document.getElementById('colorChart') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const metrics = this.skinAnalysisMetrics?.analysis?.metrics?.color;
    if (!metrics?.hueHistogramCounts || !metrics?.hueHistogramBins) return;

    // Set canvas parent to full height
    if (canvas.parentElement) {
      canvas.parentElement.style.height = '100%';
      canvas.parentElement.style.display = 'flex';
      canvas.parentElement.style.alignItems = 'center';
      canvas.parentElement.style.justifyContent = 'center';
    }

    const existingChart = Chart.getChart(canvas);
    if (existingChart) existingChart.destroy();

    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: metrics.hueHistogramBins.map(b => b.toString()),
        datasets: [{
          label: 'Hue Count',
          data: metrics.hueHistogramCounts,
          backgroundColor: 'rgba(17, 153, 142, 0.55)',
          borderColor: 'rgba(17, 153, 142, 1)',
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { top: 10, bottom: 10, left: 10, right: 10 }
        },
        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text: 'Color Hue Histogram',
            padding: { top: 5, bottom: 5 },
            font: { size: 11 }
          }
        },
        scales: {
          x: {
            grid: { color: 'rgba(0,0,0,0.05)' },
            title: { display: true, text: 'Hue Bin', font: { size: 10 } },
            ticks: { font: { size: 9 } }
          },
          y: {
            grid: { color: 'rgba(0,0,0,0.05)' },
            title: { display: true, text: 'Count', font: { size: 10 } },
            ticks: { font: { size: 9 } }
          }
        }
      }
    });
  }

  renderDiameterChart() {
    const canvas = document.getElementById('diameterChart') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const metrics = this.skinAnalysisMetrics?.analysis?.metrics?.diameter;
    if (!metrics) return;

    const existingChart = Chart.getChart(canvas);
    if (existingChart) existingChart.destroy();

    // Set canvas parent to full height
    if (canvas.parentElement) {
      canvas.parentElement.style.height = '100%';
      canvas.parentElement.style.display = 'flex';
      canvas.parentElement.style.alignItems = 'center';
      canvas.parentElement.style.justifyContent = 'center';
    }

    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Major axis (mm)', 'Minor axis (mm)', 'Area (mm²)', 'Aspect ratio'],
        datasets: [
          {
            label: 'Diameter metrics',
            data: [
              metrics.majorAxisMm ?? metrics.majorAxisPx ?? 0,
              metrics.minorAxisMm ?? metrics.minorAxisPx ?? 0,
              metrics.areaMm2 ?? metrics.areaPx ?? 0,
              metrics.aspectRatio ?? 0,
            ],
            backgroundColor: [
              'rgba(255, 153, 102, 0.75)',
              'rgba(255, 153, 102, 0.60)',
              'rgba(255, 94, 98, 0.75)',
              'rgba(255, 94, 98, 0.60)',
            ],
            borderColor: [
              'rgba(255, 153, 102, 1)',
              'rgba(255, 153, 102, 1)',
              'rgba(255, 94, 98, 1)',
              'rgba(255, 94, 98, 1)',
            ],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { top: 10, bottom: 10, left: 10, right: 10 }
        },
        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text: 'Diameter metrics summary',
            padding: { top: 5, bottom: 5 },
            font: { size: 11 }
          },
        },
        scales: {
          x: {
            grid: { color: 'rgba(0,0,0,0.05)' },
            ticks: { font: { size: 9 } }
          },
          y: {
            beginAtZero: true,
            grid: { color: 'rgba(0,0,0,0.05)' },
            ticks: { font: { size: 9 } }
          },
        },
      },
    });
  }

  activateTab(tabId: string) {
    this.isConsultationReportTabActive = tabId === 'consultationReport';
    if (this.isConsultationReportTabActive) {
      this.getReportWithPatientRecordId();
    }
  }

  getConsultationDetailById(id: string) {
    this.consultationsService
      .consultationDetailByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          this.patientHeaderInformations = res;
          this.statusClass = StatusUtils?.getCaseStatusClass(
            res?.patientStatus
          );
          this.statusText = StatusUtils?.getCaseStatusText(res?.patientStatus);
        },
      });
  }

  getPatientRecordCaseReportsById() {
    if (this.consultationId) {
      this.consultationsService
        .patientRecordCaseReportsByPatientRecordCaseId(this.consultationId)
        .subscribe({
          next: (res) => {
            if (res.patientRapport) {
              this.displayPdf(res.patientRapport, 'ai');
            }
          },
        });
    }
  }

  displayPdf(base64Pdf: string, type: string) {
    if (!base64Pdf) {
      const content = document.getElementById('consultationReport');
      if (content) {
        content.innerHTML = this.translate.instant(
          'notReadyConsultantReportDesc'
        );
      }
      this.ch.detectChanges();
      return;
    }
    const byteCharacters = atob(base64Pdf);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.src = blobUrl;
    iframe.width = '100%';
    iframe.height = '600px';
    iframe.style.border = 'none';

    let content: HTMLElement | null = null;
    if (type === 'ai') {
      content = document.getElementById('aiReport');
    } else if (type === 'preview') {
      content = document.getElementById('previewFinalReportContent');
    }

    if (content) {
      content.innerHTML = '';
      content.appendChild(iframe);
      iframe.oncancel = () => {
        URL.revokeObjectURL(blobUrl);
      };
    }
  }

  getConsultationTimeLineList(id: string) {
    this.patientsService
      .consultationTimeLineListByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          this.timeLineList = res;
        },
      });
  }

  getConclusionOptions() {
    this.consultationsService.conclusionOptions().subscribe({
      next: async (res) => {
        this.conclusionOptions = res;
        console.log("response conclusionOptions", res)
        await this.getCasesByRecordId();
        if (this.patientCases?.length) {
          const firstUncompletedCase = this.patientCases.find(
            (x) => !x.isCaseCompleted
          );
          this.activeCase =
            firstUncompletedCase ||
            this.patientCases[this.patientCases.length - 1];
          this.consultationId = this.activeCase.patientRecordCaseId;
          this.getPatientCaseDetail(this.consultationId);
          this.getConclusions(this.consultationId);
        }
      },
    });
  }

  getConclusions(patientRecordCaseId: string) {
    this.consultationsService.conclusions(patientRecordCaseId).subscribe({
      next: (res: any) => {
        if (res?.skinConditionConclusionList?.length) {
          const conclusion = res.skinConditionConclusionList.find(
            (item) => item.patientRecordCaseId === patientRecordCaseId
          );

          this.selectedDiagnosis = conclusion.diagnoseTypeCategoryId;
          this.onDiagnosisChange();
          this.selectedSubcategory = conclusion.diagnoseTypeContentId;
          this.selectedConclusionText =
            conclusion.diagnoseTypeContentDescription;
        } else if (res?.malignantMelanomaTypeConclusionList?.length) {
          this.selectedDiagnosis = MALIGNANT_SKIN_CONDITIONS;
        }
      },
    });
  }

  getDiagnoseTypeCategoryList() {
    this.consultationsService.diagnoseTypeCategoryList().subscribe({
      next: (res) => {
        this.diagnoses = res;
      },
    });
  }

  async getCasesByRecordId() {
    this.patientCases = await this.consultationsService.getCasesByRecordId(
      this.patientRecordId
    );
  }

  activeCaseChange(item: PatientCaseModel) {
    this.consultationId = item.patientRecordCaseId;
    this.initAfterActiveCaseChange();
  }

  getType(item: ConclusioOptions) {
    if (item.id === COLOR_OPTION_ID)
      return item.title[0].toLowerCase() + item.title.slice(1);
    else if (item.id === BORDER_OPTION_ID)
      return item.title[0].toLowerCase() + item.title.slice(1);
    else return '';
  }

  setSelectedConclusionOptions() {
    let selectedTexts: string[] = [];
    let storedDataDeleted = false;
    const caseKey = `selectedConclusionOptions_${this.activeCase?.patientRecordCaseId}`;
    const storedData = localStorage.getItem(caseKey);

    if (storedData && this.activeCase?.isCaseCompleted) {
      localStorage.removeItem(caseKey);
      storedDataDeleted = true;

      let activeKeys = JSON.parse(
        localStorage.getItem('activeCaseIdKeys') || '[]'
      );
      activeKeys = activeKeys.filter((key) => key !== caseKey);
      localStorage.setItem('activeCaseIdKeys', JSON.stringify(activeKeys));
    }

    if (
      storedData &&
      !storedDataDeleted &&
      JSON.parse(storedData).activeCaseId ===
      this.activeCase?.patientRecordCaseId &&
      JSON.parse(storedData).editUser === this.currentUser.id
    ) {
      const consultationOptions =
        JSON.parse(storedData)?.consultationOptions || [];
      this.selectedConclusionOptions = [...consultationOptions];
      this.setSelectedConsultationText();

      selectedTexts = this.getCleanSelectedConclusionArray();

      if (!this.selectedConclusionOptions?.length) {
        this.selectedConclusionOptions = [];
        for (const item of this.conclusionOptions) {
          const newConclusionOption: SelectedConclusionModel = {
            optionId: item.id,
            conclusionTextId: '',
            conclusionText: '',
            type: this.getType(item),
          };
          this.selectedConclusionOptions.push(newConclusionOption);
        }
      }
    } else {
      if (!this.conclusionOptions?.length) return;

      selectedTexts = this.getCleanSelectedConclusionArray();

      if (!this.selectedConclusionOptions?.length) {
        this.selectedConclusionOptions = [];
        for (const item of this.conclusionOptions) {
          const newConclusionOption: SelectedConclusionModel = {
            optionId: item.id,
            conclusionTextId: '',
            conclusionText: '',
            type: this.getType(item),
          };
          this.selectedConclusionOptions.push(newConclusionOption);
        }
      }
    }
    this.selectedConclusionOptions.forEach((item, i) => {
      const selectedItem = this.conclusionOptions[
        i
      ].conclusionOptionContents.find((x) =>
        selectedTexts.some((y) => x.conclusionText.includes(y))
      );
      if (selectedItem?.conclusionText) {
        item.conclusionText = selectedItem.conclusionText;
        item.conclusionTextId = selectedItem.id;
      }
    });

    setTimeout(() => {
      this.showDisableButtonDesc = true;
    }, 2000);
  }

  getCleanSelectedConclusionArray(): string[] {
    const selectedTexts = this.selectedConclusionText.split('.');
    return selectedTexts
      .map((item) => item.replace(/[\r\n]/g, ''))
      .filter((item) => item.trim() !== '');
  }

  updateConclusionOutput(event: Event, conclusionId?: string): void {
    let selectedId: string = '';

    if (conclusionId) {
      selectedId = conclusionId;
      return;
    } else {
      selectedId = (event.target as HTMLSelectElement).value;
    }
    this.selectedOption = this.conclusionOptions
      .flatMap((option: any) => option.conclusionOptionContents)
      .find((item: any) => item.id === selectedId);

    //console.log("conclusionOptions: ", this.conclusionOptions)

    //console.log("selectedOption: ", this.selectedOption)

    const selectedOptionId = this.selectedOption?.conclusionOptionId;
    let selectedText = this.selectedOption?.conclusionText || '';
    const consultationOption = this.selectedConclusionOptions.find(
      (x) => x.optionId === selectedOptionId
    );
    consultationOption.conclusionText = selectedText;
    consultationOption.conclusionTextId = selectedId;

    const selectedOptionData = {
      caseId: this.activeCase.patientRecordCaseId,
      optionId: selectedOptionId,
      conclusionText: selectedText,
      conclusionTextId: selectedId,
    };

    //console.log("selectedOptionData ", selectedOptionData)
    const existingIndex = this.selectedOptionsArray.findIndex(
      (item) =>
        item.caseId === this.activeCase.patientRecordCaseId &&
        item.optionId === selectedOptionId
    );

    if (existingIndex !== -1) {
      this.selectedOptionsArray[existingIndex] = selectedOptionData;
    } else {
      this.selectedOptionsArray.push(selectedOptionData);
    }

    this.selectedOptionsArray = [...new Set(this.selectedOptionsArray)];
    const formattedData = {
      editUser: this.currentUser.id,
      activeCaseId: this.activeCase.patientRecordCaseId,
      consultationOptions: this.selectedConclusionOptions,
    };

    const keyListKey = 'activeCaseIdKeys';
    let activeKeys = JSON.parse(localStorage.getItem(keyListKey) || '[]');
    const newKey = `selectedConclusionOptions_${this.activeCase.patientRecordCaseId}`;

    if (!activeKeys.includes(newKey)) {
      if (activeKeys.length >= 10) {
        const oldestKey = activeKeys.shift();
        if (oldestKey) {
          localStorage.removeItem(oldestKey);
        }
      }
      activeKeys.push(newKey);
    }
    localStorage.setItem(keyListKey, JSON.stringify(activeKeys));

    localStorage.setItem(newKey, JSON.stringify(formattedData));

    this.setSelectedConsultationText();
  }

  isAdvancedExaminaitonSelected() {
    return this.selectedOptionsArray.some(
      (item) => item.conclusionTextId === ADVANCED_EXAMINATION
    ) || (this.recommendationOption && this.recommendationOption.conclusionTextId === ADVANCED_EXAMINATION)
      ;
  }

  getAnnotationText(item) {
    if (
      !(
        item.optionId === BORDER_OPTION_ID || item.optionId === COLOR_OPTION_ID
      ) ||
      !this.annotationList?.length ||
      !item.conclusionText
    )
      return '';

    const irregularStreaksPseudopodsId = IRREGULAR_STREAKS_PSEUDOPODS_ID;

    if (item.optionId === COLOR_OPTION_ID) {
      const otherConclusions = this.annotationList.filter(
        (ann) => ann.annotationId !== irregularStreaksPseudopodsId
      );
      const uniqueDescriptions = new Set();

      this.drawnRects.forEach((rect) => {
        const anotation = otherConclusions.find(
          (ann) => ann.annotationId === rect.selectedAnnotationId
        );
        if (rect.selectedAnnotationId === anotation?.annotationId) {
          uniqueDescriptions.add(anotation.annotationDescription);
        }
      });

      return ' ' + Array.from(uniqueDescriptions).join(' ');
    }

    if (item.optionId === BORDER_OPTION_ID) {
      const irregularStreaksPseudopods = this.annotationList.find(
        (ann) => ann.annotationId === irregularStreaksPseudopodsId
      );
      const uniqueDescriptions = new Set();

      this.drawnRects.forEach((rect) => {
        const anotation = irregularStreaksPseudopods;
        if (rect.selectedAnnotationId === anotation?.annotationId) {
          uniqueDescriptions.add(anotation.annotationDescription);
        }
      });

      return ' ' + Array.from(uniqueDescriptions).join(' ');
    }

    return '';
  }

  setSelectedConsultationText() {
    if (this.selectedDiagnosis === this.malignantSkinConditions) {
      const resultText = this.selectedConclusionOptions
        .map(
          (item) => item.conclusionText.trim() + this.getAnnotationText(item)
        )
        .filter((text) => text !== '')
        .join('\r');
      console.log("resultText ", resultText)
      this.selectedConclusionText = resultText;
    }
  }

  isSelectedOption(consultationText: string) {
    return this.selectedConclusionOptions.some(
      (x) => x.conclusionText === consultationText
    );
  }

  isSelectDisable(option: ConclusioOptions) {
    if (
      this.currentUser?.role === this.userRole.OrganizationAdmin ||
      this.currentUser?.role === this.userRole.GeneralPractitioner
    )
      return true;
    if (this.activeCase?.isRecordCompleted) return true;
    if (!this.selectedConclusionOptions?.length) return false;
    const isLastOption =
      option.id ===
      this.selectedConclusionOptions[this.selectedConclusionOptions.length - 1]
        .optionId;
    const hasEmptyOptions = this.selectedConclusionOptions.filter(
      (x) => x.conclusionText == ''
    );
    if (isLastOption && hasEmptyOptions?.length > 1) return true;
    return false;
  }

  isSubmitButtonDisable() {
    if (this.selectedSubcategory.length) return false;
    const hasReportedImg = this.patientRecordCaseImages?.some(
      (x) => x.isReportImage
    );
    if (!this.selectedConclusionOptions?.length || !hasReportedImg) return true;
    const hasEmptyOptions = this.selectedConclusionOptions.filter(
      (x) => x.conclusionText == ''
    );
    if (hasEmptyOptions?.length) return true;
    if (this.currentUser?.role === this.userRole.OrganizationAdmin) return true;
    return false;
  }

  isPreviewButtonDisable() {
    const hasReportedImg = this.patientRecordCaseImages?.some(
      (x) => x.isReportImage
    );
    if (!hasReportedImg) return true;
    const hasUncompletedCase = this.patientCases.some(
      (x) => x.isCaseCompleted == false
    );
    if (!hasUncompletedCase) return false;
    return this.isSubmitButtonDisable();
  }

  isAllCasesCompleted() {
    const hasUncompletedCase = this.patientCases.some(
      (x) => x.isCaseCompleted == false
    );
    if (hasUncompletedCase) return false;
    return true;
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = '/assets/media/not-found.jpeg';
  }

  async previewReport() {
    const selectedSubcategoryObj = this.getSelectedSubcategoryObj();
    const formData = {
      patientRecordCaseId: this.consultationId,
      patientRecordId: this.patientRecordId,
      conclusion: this.selectedConclusionText,
      diagnoseTypeContentId: selectedSubcategoryObj?.id ?? null,
      diagnoseTypeContentDescription: selectedSubcategoryObj?.description ?? null
    };
    this.consultationsService
      .previewReport(formData, this.patientRecordId)
      .subscribe({
        next: () => {
          this.checkResultConsultationReport();
        },
      });
  }

  checkResultConsultationReport() {
    this.consultationsService
      .checkConsultationReport(this.patientRecordId)
      .subscribe({
        next: (res) => {
          if (!res) {
            setTimeout(() => {
              this.checkResultConsultationReport();
            }, 2000);
            this.previewReportErrorText = this.translate.instant(
              'notReadyPreviewReportDesc'
            );
          } else {
            this.previewReportErrorText = null;
            this.getReportWithPatientRecordId();
          }
        },
      });
  }

  startCheckConsultationReport() {
    const checkInterval = 2000;

    this.subscription = interval(checkInterval)
      .pipe(
        switchMap(() => this.checkConsultationReport(this.patientRecordId)),
        takeWhile(
          (isConsultationReportGenerated) => !isConsultationReportGenerated,
          true
        )
      )
      .subscribe({
        next: (isConsultationReportGenerated) => {
          if (isConsultationReportGenerated) {
            this.getReportWithPatientRecordId();
            this.subscription.unsubscribe();
          } else {
            this.previewReportErrorText = this.translate.instant(
              'notReadyPreviewReportDesc'
            );
          }
        },
        error: () => {
          this.subscription.unsubscribe();
        },
      });
  }

  checkConsultationReport(patientRecordId: string): Observable<boolean> {
    return this.consultationsService
      .checkConsultationReport(patientRecordId)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(() => {
          return of(false);
        })
      );
  }

  preventForbiddenCharacters(
    event: Event,
    type: 'number' | 'text' | 'email' | 'tel'
  ): void {
    this.inputValidationService.preventForbiddenCharacters(event, type);
  }

  downloadChatFile(path: string, fileName: string) {
    const base64Data = path.includes(',') ? path.split(',')[1] : path;

    const binaryString = window.atob(base64Data);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  async getConsultationMailTemplateAsync() {
    const templateResponse =
      await this.consultationsService.getConsultationReportTemplate();

    this.notificationMailTemplate = this.consultationsService
      .getConsultationReportTemplateById(
        this.consultationId,
        templateResponse.body
      )
      .subscribe((res) => {
        this.notificationMailTemplate = res;
      });
  }

  async getUserNotificationSettings() {
    const userNotificationSettings = await this.usersService
      .getUserNotificationSettings(
        this.patientHeaderInformations?.generalPractitionerUserName ?? ''
      )
      .toPromise();
    return userNotificationSettings;
  }

  async sendReport() {
    const conclusionOptionInfos: ConclusionOptionInfoModel[] = [];
    for (const item of this.selectedConclusionOptions) {
      const newItem: ConclusionOptionInfoModel = {
        conclusionOptionId: item.optionId,
        conclusionOptionContentId: item.conclusionTextId,
      };
      if (item.optionId === COLOR_OPTION_ID) {
        newItem.annotations = this.drawnRects
          .filter(
            (rect) =>
              rect.selectedAnnotationId !== IRREGULAR_STREAKS_PSEUDOPODS_ID
          )
          .map((rect) => ({
            annotationId: rect.selectedAnnotationId,
          }));
      } else if (item.optionId === BORDER_OPTION_ID) {
        newItem.annotations = this.drawnRects
          .filter(
            (rect) =>
              rect.selectedAnnotationId === IRREGULAR_STREAKS_PSEUDOPODS_ID
          )
          .map((rect) => ({
            annotationId: rect.selectedAnnotationId,
          }));
      } else {
        newItem.annotations = [];
      }

      conclusionOptionInfos.push(newItem);
    }

    if (!this.activeCase.isCaseCompleted) {
      await this.consultationsService.completePatientRecordCase(
        this.consultationId,
        this.selectedDiagnosis !== this.malignantSkinConditions
          ? []
          : conclusionOptionInfos,
        this.selectedSubcategory
      );
      await this.getCasesByRecordId();
    }

    const isReferral =
      this.currentUser?.role === this.userRole.GeneralPractitioner &&
      this.isComeFromReferral;

    const formData: any = {
      patientRecordCaseId: this.consultationId ?? '',
      patientRecordId: this.patientRecordId ?? '',
      conclusion: this.selectedConclusionText ?? '',
      emailTemplateBody: this.notificationMailTemplate?.body ?? '',
      email: this.patientCaseDetails?.email ?? '',
      phone: this.patientCaseDetails?.phone ?? '',
      pidNo: this.currentUser?.pidNo ?? '',
      isReferralCompleted: isReferral,
    };

    if (
      this.currentUser?.role === this.userRole.Dermatologist &&
      this.isAdvancedExaminaitonSelected()
    ) {
      const userNotificationSettings = await this.getUserNotificationSettings();

      (formData.generalPractitionerName =
        userNotificationSettings?.generalPractitionerName),
        (formData.generalPractitionerLastName =
          userNotificationSettings?.generalPractitionerLastName),
        (formData.generalPractitionerNotificationEmail =
          userNotificationSettings?.email);
      formData.isEmailNotificationsEnabled =
        userNotificationSettings?.isEmailNotificationsEnabled;
    }

    this.consultationsService
      .sendReport(formData, this.patientRecordId)
      .subscribe({
        next: () => {
          if (this.selectedOption.id === ADVANCED_EXAMINATION) {
            this.toastService.showToast(
              this.translate.instant('informations.sendProcessCompleted'),
              'success'
            );
          } else {
            this.toastService.showToast(
              this.translate.instant('successSendReportDesc'),
              'success'
            );
          }

          this.isOverlayLoading = true;

          // this.getReport();
          // if (this.consultationId) {
          //   this.getConsultationDetailById(this.consultationId);
          // }
          setTimeout(() => {
            const caseKey = `selectedConclusionOptions_${this.activeCase?.patientRecordCaseId}`;
            localStorage.removeItem(caseKey);

            if (
              this.currentUser?.role === this.userRole.GeneralPractitioner &&
              this.isComeFromReferral
            ) {
              this.router.navigate(['/referral/list']);
            } else {
              this.router.navigate(['/consultation/list']);
            }
          }, 1000);
        },
      });
  }

  getReportWithPatientRecordId() {
    this.consultationsService
      .getReportWithPatientRecordId(this.patientRecordId)
      .subscribe({
        next: (res) => {
          if (res?.patientRapport) {
            this.displayPdf(res.patientRapport, 'preview');
          }
        },
      });
  }

  showCaseDetails(index: number, selectItem: any): void {
    if (selectItem.patientRecordCaseId || selectItem.patientRecordId) {
      this.patientRecordCaseImages = [];
      this.isImagesLoading = true;
      this.selectedIndex = index;
      this.getPatientInformationsAndLocation(selectItem.patientRecordCaseId);
      this.getPatientCaseDetail(selectItem.patientRecordCaseId);
      this.getPatientRecordCaseImagesById(selectItem.patientRecordCaseId);
    }
  }

  getPatientInformationsAndLocation(id: string) {
    this.consultationsService
      .consultationDetailByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          if (res) {
            this.patientHeaderInformations = res;
          }
        },
      });
  }

  async getPatientCaseDetail(id: string) {
    this.patientsService.patientRecordCaseDetail(id).subscribe({
      next: async (res) => {
        if (res) {
          this.patientCaseDetails = res;
          if (res.conclusion) {
            this.selectedConclusionText = res.conclusion;
          }
          this.setSelectedConclusionOptions();
          this.getConsultationDetailById(this.consultationId);
          this.getPatientRecordCaseImagesById(this.consultationId);
          this.getSelectedImage();
          this.getConsultationTimeLineList(this.consultationId);
          this.getPatientConsultationImageHistory(this.consultationId);
          await this.getAiImages();
          this.getSkinAnalysisMetrics(this.consultationId);
          this.getChatList(this.consultationId);
          this.getConclusions(this.consultationId);
          await this.getUserNotificationSettings();
        }
      },
    });
  }

  getSkinAnalysisMetrics(id: string) {
    this.consultationsService.getSkinAnalysisMetrics(id).subscribe({
      next: (res) => {
        // If backend doesn't have metrics yet, keep the mock data (or previous data)
        const hasBackendMetrics = !!res?.analysis?.metrics;
        if (hasBackendMetrics) {
          this.skinAnalysisMetrics = res;
        } else if (!this.skinAnalysisMetrics?.analysis?.metrics) {
          // nothing meaningful currently loaded; keep null-ish backend response
          this.skinAnalysisMetrics = res;
        }
      },
      error: (err) => {
        console.error('Error fetching skin analysis metrics:', err);
        if (this.activeRightTab === '#aiReport') {
          this.ch.detectChanges();
        }
      }
    });
  }

  getPatientRecordCaseImagesById(id: string) {
    this.isImagesLoading = true;
    this.consultationsService.patientRecordImagesByPatientId(id).subscribe({
      next: (res) => {
        if (res.length > 0) {
          this.patientRecordCaseImages = res.map(
            (image: any, index: number) => ({
              src: `data:image/jpeg;base64,${image.fileData}`,
              id: `imageModal${index + 1}`,
              alt: `Lesion Close-up ${index + 1}`,
              patientRecordId: image.patientRecordCaseId,
              imageId: image.id,
              isSelected: image.isSelected,
              isReportImage: image.isReportImage,
            })
          );
          this.getReportedCaseImages(this.consultationId);
        }
        this.isImagesLoading = false;
      },
      error: () => {
        this.isImagesLoading = false;
      },
    });
  }

  getPatientConsultationImageHistory(id: string) {
    this.patientsService.patientRecordCaseImagesHistory(id).subscribe({
      next: (res) => {
        if (res.length > 0) {
          this.patientHistoryImages = res.map((element: any) => ({
            createdDate: element.createdDate,
            images: element.images.map((imageItem: any) => ({
              src: `data:image/jpeg;base64,${imageItem.fileData}`,
              patientRecordCaseId: imageItem.patientRecordCaseId,
              imageId: imageItem.imageId,
              isReportImage: imageItem.isReportImage,
              isSelected: imageItem.isSelected,
            })),
          }));

          this.getReportedCaseImages(this.consultationId);
        }
      },
    });
  }

  getReportedCaseImages(id: string) {
    this.patientsService.patientReportCaseImages(id).subscribe({
      next: (res) => {
        if (res) {
          this.patientCaseReportImages = {
            patientRecordCaseId: res.patientRecordCaseId,
            currentCaseImageId: res.currentCaseImageId,
            historyCaseImageId: res.historyCaseImageId,
          };
          this.updateCurrentCaseImageDataAsReportedImages();
          this.updateHistoryCaseImageDataAsReportedImages();
        }
      },
    });
  }

  updateCurrentCaseImageDataAsReportedImages() {
    var data = this.patientRecordCaseImages.find(
      (x) => x.imageId == this.patientCaseReportImages.currentCaseImageId
    );
    var index = this.patientRecordCaseImages.findIndex(
      (x) => x.imageId == this.patientCaseReportImages.currentCaseImageId
    );
    if (data != null) {
      data.isReportImage = true;
    }

    this.updateCurrentCaseData(index > 0 ? index : 0);
  }

  updateHistoryCaseImageDataAsReportedImages() {
    this.patientHistoryImages.forEach((historyGroup, historyGroupIndex) => {
      const targetImage = historyGroup.images.find(
        (image) =>
          image.imageId === this.patientCaseReportImages.historyCaseImageId
      );

      if (targetImage) {
        targetImage.isReportImage = true;
        //this.updateHistoryCaseData(historyGroupIndex);
      }
    });
  }

  getStatusClass(status: number): string {
    return StatusUtils?.getCaseStatusClass(status);
  }

  getStatusText(status: number): string {
    return StatusUtils?.getCaseStatusText(status);
  }

  updateContent(images: string[], item: any, pivot: string) {
    this.selectedItem = item;
  }

  handleFileClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.fileInput.nativeElement.click();
  }

  handleFileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fileCount = input.files.length;
      this.file = input.files[0];
      input.value = '';
    }
  }

  getChatList(id: string) {
    if (!id) return;
    this.chatService.chatList(id).subscribe({
      next: (res) => {
        if (res) {
          this.chatList = res;
          this.scrollToBottom();
          this.getUserAvatars();
          this.getOtherUserName();
        }
      },
    });
  }

  getUserAvatars() {
    const userIds = this.chatList?.map((item) => item.createdUserId);

    const formData = {
      userIds,
    };

    this.chatService.userAvatars(formData).subscribe({
      next: (res) => {
        this.currentUserAvatar = res?.find(
          (item) => item.userId === this.currentUser?.id
        )?.avatarImage
          ? `data:image/jpeg;base64,${res.find((item) => item.userId === this.currentUser?.id)
            ?.avatarImage
          }`
          : 'assets/media/profile/profile-picture.png';

        this.otherUserAvatar = res?.find(
          (item) => item.userId !== this.currentUser?.id
        )?.avatarImage
          ? `data:image/jpeg;base64,${res.find((item) => item.userId !== this.currentUser?.id)
            ?.avatarImage
          }`
          : 'assets/media/profile/profile-picture.png';
      },
    });
  }

  sendChat(id: string): void {
    if (this.messageText.trim() === '' && this.file == null) return;
    if (
      this.currentUser?.role === this.userRole.OrganizationAdmin ||
      this.currentUser?.role === this.userRole.Assistant
    )
      return;

    this.isChatSending = true;
    const createChatModel: CreateChatModel = {
      patientRecordCaseId: id,
      patientName: this.patientHeaderInformations.name,
      patientSurname: this.patientHeaderInformations.lastName,
      patientRecordCaseNumber:
        this.patientHeaderInformations.patientRecordCaseNumber,
      createdUserName: this.currentUser?.name || '',
      message: this.messageText || '',
      expertUserName: this.patientHeaderInformations?.expertUserName || '',
      generalPractitionerUserName:
        this.patientHeaderInformations?.generalPractitionerUserName || '',
      file: this.file,
    };

    this.chatService.chat(createChatModel).subscribe({
      next: (res) => {
        if (res) {
          this.messageText = '';
          this.file = null;
          this.fileCount = null;

          this.getChatList(this.consultationId);
        }
      },

      complete: () => {
        this.isChatSending = false;
      },
    });
  }

  scrollToBottom(): void {
    const interval = setInterval(() => {
      if (this.chatContainer && this.chatContainer.nativeElement) {
        this.chatContainer.nativeElement.scrollTop =
          this.chatContainer.nativeElement.scrollHeight + 200;
        clearInterval(interval);
      }
    }, 500);
  }

  get hasAnySelectedImage(): any {
    return this.radioSelectedImage != null ? true : false;
  }

  getSelectedImage(): any {
    this.selectedImage =
      this.patientRecordCaseImages.find((image) => image.isSelected) || null;
    return this.selectedImage;
  }

  selectImage(imag: any) {
    this.radioSelectedImage = this.patientRecordCaseImages.find(
      (x) => x.id == imag.id
    );
  }

  sendReAnalysis(): void {
    this.isOverlayLoading = true;
    this.patientsService.sendAI(this.radioSelectedImage.imageId).subscribe({
      next: () => {
        this.toastService.showToast(
          this.translate.instant('informations.sendProcessCompleted'),
          'success'
        );

        setTimeout(() => {
          this.router.navigate(['/consultation/list']);
        }, 4000);
      },
    });
  }

  selectImageForReport(imageData: any, event: MouseEvent) {
    event.preventDefault();
    const isChecked = (event.target as HTMLInputElement).checked;

    const formData = {
      patientRecordCaseId: this.consultationId,
      imageId: isChecked ? imageData.imageId : null,
      isFromCurrentCase: true,
      isFromHistoryCase: false,
    };

    this.patientsService
      .updateSelectedPatientRecordCaseImageForReport(
        this.currentCaseData.patientRecordCaseId,
        formData
      )
      .subscribe({
        next: (res) => {
          if (res) {
            this.toastService.showToast(
              this.translate.instant('informations.reportImageUpdate'),
              'success'
            );

            this.getPatientRecordCaseImagesById(this.consultationId);
            this.currentCaseData.isReportImage = isChecked;
          } else {
            this.toastService.showToast(
              this.translate.instant('alerts.reportImageCountAlert'),
              'warning'
            );
          }
        },
      });
  }
  selectImageForReportFromHistory(imageData: any, event: MouseEvent) {
    event.preventDefault();
    const isChecked = (event.target as HTMLInputElement).checked;

    const formData = {
      patientRecordCaseId: this.consultationId,
      imageId: isChecked ? imageData.imageId : null,
      isFromCurrentCase: false,
      isFromHistoryCase: true,
    };

    this.patientsService
      .updateSelectedPatientRecordCaseImageForReport(
        this.consultationId,
        formData
      )
      .subscribe({
        next: (res) => {
          if (res) {
            this.toastService.showToast(
              this.translate.instant('informations.reportImageUpdate'),
              'success'
            );

            this.getPatientConsultationImageHistory(this.consultationId);
            this.fullscreenImage.isReportImage = isChecked;
          } else {
            this.toastService.showToast(
              this.translate.instant('alerts.reportImageCountAlert'),
              'warning'
            );
          }
        },
      });
  }

  updateHistoryImage;

  skinTypeTextHeader(): any {
    const skinTypeHeaderText = this.translate.instant('skinTypeHeader');
    switch (this.patientCaseDetails?.dermatologyCaseInformation?.skinType) {
      case SkinTypes.Type1:
        return `${skinTypeHeaderText} 1 `;

      case SkinTypes.Type2:
        return `${skinTypeHeaderText} 2 `;

      case SkinTypes.Type3:
        return `${skinTypeHeaderText} 3 `;

      case SkinTypes.Type4:
        return `${skinTypeHeaderText} 4 `;

      case SkinTypes.Type5:
        return `${skinTypeHeaderText} 5 `;

      case SkinTypes.Type6:
        return `${skinTypeHeaderText} 6 `;

      default:
        return '';
    }
  }

  generalAppearanceTextHeader(): any {
    let generalAppearanceText: string = '';

    if (
      this.patientCaseDetails?.dermatologyCaseInformation?.generalAppearance
        ?.freckles
    ) {
      generalAppearanceText += this.translate.instant('freckles') + ', ';
    }
    if (
      this.patientCaseDetails?.dermatologyCaseInformation?.generalAppearance
        ?.redHair
    ) {
      generalAppearanceText += this.translate.instant('redHair') + ', ';
    }
    if (
      this.patientCaseDetails?.dermatologyCaseInformation?.generalAppearance
        ?.lightColoredEyes
    ) {
      generalAppearanceText +=
        this.translate.instant('lightColoredEyes') + ', ';
    }
    if (generalAppearanceText.endsWith(', ')) {
      generalAppearanceText = generalAppearanceText.slice(0, -2);
    }
    return generalAppearanceText;
  }

  medicalHistoryTextHeader(): any {
    let medicalHistoryText: string = '';
    // riskFactors
    this.patientCaseDetails.dermatologyCaseInformation?.riskFactors?.forEach(
      (element) => {
        medicalHistoryText += element.name + ', ';
      }
    );
    // dermatologicDiseases
    this.patientCaseDetails.dermatologyCaseInformation?.dermatologicDiseases?.forEach(
      (element) => {
        medicalHistoryText += element.name + ', ';
      }
    );
    // diseaseCousingImmunosuppressions
    this.patientCaseDetails.dermatologyCaseInformation?.diseaseCousingImmunosuppressions?.forEach(
      (element) => {
        medicalHistoryText += element.name + ', ';
      }
    );
    // diseaseCousingImmunosuppressions
    this.patientCaseDetails.dermatologyCaseInformation?.diseaseCousingImmunosuppressions?.forEach(
      (element) => {
        medicalHistoryText += element.name + ', ';
      }
    );
    // neoplasticDiseases
    this.patientCaseDetails.dermatologyCaseInformation?.neoplasticDiseases?.forEach(
      (element) => {
        medicalHistoryText += element.name + ', ';
      }
    );
    // otherDiseases
    this.patientCaseDetails.dermatologyCaseInformation?.otherDiseases?.forEach(
      (element) => {
        medicalHistoryText += element.name + ', ';
      }
    );

    if (medicalHistoryText.endsWith(', ')) {
      medicalHistoryText = medicalHistoryText.slice(0, -2);
    }
    return medicalHistoryText;
  }

  medicationsTextHeader() {
    let medicationsText: string = '';

    if (this.patientCaseDetails.medications) {
      this.patientCaseDetails.medications.forEach((element) => {
        medicationsText += element.name + ', ';
      });
    }

    if (medicationsText.endsWith(', ')) {
      medicationsText = medicationsText.slice(0, -2);
    }

    return medicationsText;
  }

  complatintsTextHeader(): any {
    let complatintsTextHeader: string = '';

    const lesionCharacteristic =
      this.patientCaseDetails?.dermatologyCaseInformation?.lesionCharacteristic;

    if (lesionCharacteristic?.bleeding) {
      complatintsTextHeader += this.translate.instant('bleeding') + ', ';
    }
    if (lesionCharacteristic?.pain) {
      complatintsTextHeader += this.translate.instant('pain') + ', ';
    }
    if (lesionCharacteristic?.itching) {
      complatintsTextHeader += this.translate.instant('itching') + ', ';
    }
    if (lesionCharacteristic?.ulceration) {
      complatintsTextHeader += this.translate.instant('ulceration') + ', ';
    }

    if (complatintsTextHeader.endsWith(', ')) {
      complatintsTextHeader = complatintsTextHeader.slice(0, -2);
    }

    return complatintsTextHeader;
  }

  changeTextHeader(): any {
    let changeHeaderText: string = '';

    const lesionCharacteristic =
      this.patientCaseDetails?.dermatologyCaseInformation?.lesionCharacteristic;

    if (lesionCharacteristic?.hasSizeChange) {
      changeHeaderText += this.translate.instant('size') + ', ';
    }
    if (lesionCharacteristic?.hasGreaterThan6mmChange) {
      changeHeaderText += this.translate.instant('greatherThan6mm') + ', ';
    }
    if (lesionCharacteristic?.hasBorderChange) {
      changeHeaderText += this.translate.instant('border') + ', ';
    }
    if (lesionCharacteristic?.hasColorChange) {
      changeHeaderText += this.translate.instant('color') + ', ';
    }

    if (changeHeaderText.endsWith(', ')) {
      changeHeaderText = changeHeaderText.slice(0, -2);
    }

    return changeHeaderText;
  }

  durationTextHeader(): any {
    let durationHeaderText: string = '';

    if (
      this.patientCaseDetails.dermatologyCaseInformation?.lesionCharacteristic
        ?.hasCongenital
    ) {
      durationHeaderText = this.translate.instant('congenital');
    } else {
      durationHeaderText =
        this.patientCaseDetails.dermatologyCaseInformation?.lesionCharacteristic
          ?.customCongenitalValue;
    }
    return durationHeaderText;
  }

  handleDoubleClickForCurrentImage(image: any): void {
    this.currentCaseData.imageId = image.imageId;
    this.currentCaseData.patientRecordCaseId = image.patientRecordId;
    this.currentCaseData.src = image.src;
    this.currentCaseData.isSelected = image.isSelected;
    this.currentCaseData.isReportImage = image.isReportImage;

    document.getElementById('allCaseImages').style.display = 'none';
    const caseImageTab = document.querySelector('[href="#caseImage"]');
    if (caseImageTab) {
      (caseImageTab as HTMLElement).click();
    }
  }

  handleDoubleClickForHistoryImage(image: any) {
    this.showImageGallery = false;
    this.fullscreenImage.imageId = image.imageId;
    this.fullscreenImage.isReportImage = image.isReportImage;
    this.fullscreenImage.isSelected = image.isSelected;
    this.fullscreenImage.patientRecordCaseId = image.patientRecordCaseId;
    this.fullscreenImage.src = image.src;
  }

  closeFullscreenImage() {
    this.showImageGallery = true;
  }

  showAiImagesFullscreen(image: any) {
    this.showImageGalleryAi = false;
    this.fullscreenImageAi = image;
  }

  closeAiImagesFullscreen() {
    this.showImageGalleryAi = true;
    this.fullscreenImageAi = null;
  }

  updateCurrentCaseData(index) {
    const selectedImage = this.patientRecordCaseImages[index];
    if (selectedImage) {
      this.currentCaseData.imageId = selectedImage.imageId;
      this.currentCaseData.patientRecordCaseId = selectedImage.patientRecordId;
      this.currentCaseData.src = selectedImage.src;
      this.currentCaseData.isSelected = selectedImage.isSelected;
      this.currentCaseData.isReportImage = selectedImage.isReportImage;
    }
  }

  updateHistoryCaseData(index) {
    const selectedImage = this.patientHistoryImages[index];
    if (selectedImage) {
      selectedImage.images.forEach((item) => {
        this.historyCaseDataList.push({
          src: item.fileData || null,
          isSelected: item.isSelected,
          isReportImage: item.isReportImage,
          imageId: item.imageId,
          patientRecordCaseId: item.patientRecordCaseId,
        });
      });
    }
  }

  prevImage() {
    if (this.selectedImageIndex > 0) {
      this.selectedImageIndex--;
    } else {
      this.selectedImageIndex = this.patientRecordCaseImages.length - 1;
    }
    this.updateCurrentCaseData(this.selectedImageIndex);
  }

  nextImage() {
    if (this.selectedImageIndex < this.patientRecordCaseImages.length - 1) {
      this.selectedImageIndex++;
    } else {
      this.selectedImageIndex = 0;
    }
    this.updateCurrentCaseData(this.selectedImageIndex);
  }

  handleMouseMove(event: MouseEvent) {
    const button = document.getElementById('myAccordionButton');
    if (button) {
      const rect = button.getBoundingClientRect();
      const threshold = 50;
      if (event.clientY < rect.top + threshold) {
        this.openAccordion('collapseOne');
      }
    }
  }

  openAccordion(id) {
    const element = document.getElementById(id);
    if (element && !element.classList.contains('show')) {
      element.classList.add('show');
    }
  }

  closeAccordion(id) {
    const element = document.getElementById(id);
    if (element && element.classList.contains('show')) {
      element.classList.remove('show');
    }
  }

  getOtherUserName(): void {
    const isOtherUserChatExist = this.chatList?.some(
      (chat) => chat.createdUserId !== this.currentUser?.id
    );
    if (isOtherUserChatExist) {
      this.otherUserName = this.chatList?.find(
        (chat) => chat.createdUserId !== this.currentUser?.id
      )?.createdUserName;
    }
  }

  lang(): string {
    return localStorage.getItem('selectedLanguage');
  }

  isSelectedAdvancedExamination() {
    this.updateConclusionOutput(null, ADVANCED_EXAMINATION);
  }

  async getAiImages() {
    if (!this.consultationId) return;
    this.isAiLoading = true;
    try {
      const res = await this.consultationsService.getAiImages(
        this.consultationId,
        () => { },
        (err) => { }
      );
      if (res) {
        const imageKeys = [
          'gaugeImage',
          'radarChartImage',
          'lesionSpaceImage',
          'cbirImage',
          'blendedImage',
          'spaceImage',
          'saturationSpaceImage',
          'cbir1Image',
          'cbir2Image',
          'cbir3Image',
          'cbir4Image',
          'cbir5Image',
        ];

        imageKeys.forEach((key) => {
          if (res[key] && !res[key].startsWith('data:image')) {
            res[key] = `data:image/jpeg;base64,${res[key]}`;
          }
        });

        // CBIR imajlarından en az biri varsa AI Report tab'ı göster
        const hasCbirImages = !!(
          res.cbir1Image ||
          res.cbir2Image ||
          res.cbir3Image ||
          res.cbir4Image ||
          res.cbir5Image
        );

        this.aiImages = {
          ...this.aiImages,
          ...res,
          allImagesExist: hasCbirImages
        };
      }
    } catch (error) {
      console.error(error);
      this.aiImages.allImagesExist = false;
    } finally {
      this.isAiLoading = false;
    }
  }
}
